import React from "react"
import { useTranslation } from "react-i18next"
import { ButtonWrapper } from "./styles"

interface ButtonProps {
  textId: string
  children?: any
  colour?: string
  minWidth?: number
  size?: string
  outline?: boolean,
  disabled: boolean
}

const Button: React.FC<ButtonProps> = ({
  colour,
  minWidth,
  outline,
  size,
  textId,
  disabled
}) => {
  const { t } = useTranslation()
  return (
    <ButtonWrapper
      className="button"
      colour={colour}
      outline={outline}
      size={size}
      minWidth={minWidth}
      type="submit"
      disabled={disabled}
    >
      {t(textId)}
    </ButtonWrapper>
  )
}

export default Button
